import { SlotPlanInfo } from '@@partner:types:app'
import SlotTableContainer from '@components/shop/form/slot/SlotTableContainer'
import React, { useCallback, useEffect, useState } from 'react'
import { Button, ButtonGroup, Modal } from 'rsuite'

type props = {
  slotPlans: SlotPlanInfo[]
  open: boolean
  onChange: (updatedSlots: SlotPlanInfo[]) => void
  onClose: () => void
}

export default function DeliveryZoneSlots ({
  slotPlans,
  open,
  onChange,
  onClose
}: props) {
  const [ state, setState ] = useState<SlotPlanInfo[]>(slotPlans || [])

  useEffect(() => {
    setState(slotPlans)
  }, [ slotPlans ])

  // reset state and close modal
  const handleCloseModal = useCallback(() => {
    setState(slotPlans)
    onClose()
  }, [ slotPlans, onClose ])
  
  const handleSave = () => {
    onChange(state)
    onClose()
  }

  return (
    <Modal 
      size='lg'
      overflow={true}
      open={open} 
      onClose={handleCloseModal}
    >
      <Modal.Header>Слоты</Modal.Header>
      <Modal.Body>
        <SlotTableContainer 
          value={state}
          onChange={setState}
        />

        <ButtonGroup justified className='my-10'>
          <Button onClick={handleCloseModal}>Отмена</Button>
          <Button
            onClick={handleSave}
            color="green"
            appearance="primary"
          >
            OK
          </Button>
        </ButtonGroup>
      </Modal.Body>
    </Modal>
  )
}